import { useAuth0 } from "@auth0/auth0-react";
import Result from "../utils/result.utils.ts";
import PdfExtractionAPI from "../api/pdf-extraction-api.ts";
import { mapExtractionToPrefill } from "../utils/pdf-extraction.utils.ts";
import useDealBuilderInputsStore from "../../stores/deal-builder-inputs.store.ts";
import useDealBuilderExtractionStore from "../../stores/deal-builder-extraction.store.ts";

export type ExtractionSummary = {
    maturities: number,
    reviewFields: string[],
    warnings: string[],
};

export default function usePdfExtraction() {
    const { getAccessTokenSilently } = useAuth0();
    const { setExtraction, setExtracting } = useDealBuilderExtractionStore();

    async function extractFromPdf(file: File): Promise<Result<ExtractionSummary>> {
        setExtracting(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await PdfExtractionAPI.extractPdf(token, file);
            if ("error" in response) {
                return { valid: false, error: response.message };
            }

            const currentInputs = useDealBuilderInputsStore.getState();
            const prefill = mapExtractionToPrefill(response, currentInputs);

            currentInputs.updateAll({ ...currentInputs, ...prefill.inputPatch });
            setExtraction(prefill.bonds, prefill.termRanges, prefill.reviewFields, prefill.warnings, file.name);

            return {
                valid: true,
                body: {
                    maturities: prefill.bonds.length,
                    reviewFields: prefill.reviewFields,
                    warnings: prefill.warnings,
                },
            };
        } finally {
            setExtracting(false);
        }
    }

    return { extractFromPdf };
}
